import { render, staticRenderFns } from "./DepositsAvailable.vue?vue&type=template&id=25e502ca&scoped=true"
import script from "./DepositsAvailable.vue?vue&type=script&lang=js"
export * from "./DepositsAvailable.vue?vue&type=script&lang=js"
import style0 from "./DepositsAvailable.vue?vue&type=style&index=0&id=25e502ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e502ca",
  null
  
)

export default component.exports